const background = {
    darkMayo: '#EFE1CC',
    lightMayo: '#FAF5ED'
}

const border = {
    bbq30: '#CBBDB9',
    black: '#000000',
    darkGrey: 'rgba(0, 0, 0, 0.06)',
    lightGrey: '#EBEAEA',
    neutralBorder: '#E2E0DF'
}

const branding = {
    bbqBrown: '#502314',
    crunchyGreen: '#198737',
    crunchyGreenDisabled: 'rgba(25, 135, 55, 0.4)',
    fieryRed: '#D62300',
    lightRed: '#FEDCE0',
    lightBrown: '#87604F',
    lightOrange: '#F9DFCD',
    lightGreen: '#81E59C',
    mayoEggWhite: '#F5EBDC',
    meltyYellow: '#FFAA00',
    flamingOrange: '#FF8732',
    white: '#FFFFFF',
    lightBlue: '#F6F5EF',
    lightBlueWhite: '8DDAF7'
}

const text = {
    accentuation: '#762823',
    darkBrown: '#2B0200',
    disable: '#EBEBEB',
    greyBbqBrown: '#A69B97',
    greyDisable: '#706D6C',
    blackLight: '#3C3C3C'
}

export const colors = {
    ...background,
    ...border,
    ...branding,
    ...text
}
